// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"01f2426d","377":"e462debd","523":"2054e462","816":"4a89f83b","913":"50954fa4"}[chunkId] + ".chunk.js";
};